export const FIRMS_SET_FIRMS = "firms/set-firms";
export const FIRMS_SET_FIRMSTRADELIMITS = "firms/set-firms-trade-limit";
